export const ComputeResource = {
  "Header_LeftBracket": "左括弧",
  "Headrt_Data": "數據",
  "Headrt_Operator": "操作符",
  "Headrt_Value": "值",
  "Headrt_RightBracket": "右括弧",
  "Headrt_Relation": "關係",
  "Data_Code": "編號",
  "Data_Name": "名稱",
  "Relation_And": "並且",
  "Relation_Or": "或者",
  "Notice_Success": "運算式生成！",
  "Notice_NotComplate": "請確保必填項填寫完整！",
  "Notice_SuccessClear": "條件已清空！",
  "Notice_PleaseSelectRow": "請先選中一行條件！",
  "Notice_NotAllowSelectRoot": "禁止選擇根節點！",
  "Error_Data_Oper": "條件第 %s 行 數據、操作符 未設定！",
  "Error_Data": "條件第 %s 行 數據 未設定！",
  "Error_Oper": "條件第 %s 行 操作符 未設定！",
  "Error_ValueNotSet": "條件第 %s 行 值 未設定！",
  "Error_Bracket": "條件括弧閉合异常，請檢查！",
  "Button_Advaned": "高級運算式",
  "Button_Save": "確定",
  "Button_Reset": "重置",
  "Button_Cancel": "取消",
  "HeadButton_Up": "上移",
  "HeadButton_Down": "下移",
  "HeadButton_Top": "上移",
  "HeadButton_Bottom": "置底",
  "ComputeExpression": "條件運算式",
  "AdvancedExpression": "高級運算式",
  "Advanced_Save": "保存",
  "Advanced_Cancel": "取消",
  "DeleteConfirmLeft": "確認删除第 ",
  "DeleteConfirmRight": " 行數據?"
}